<template>
    <v-data-table
        :headers="headers"
        :items="items"
        item-key="_id"
        :expanded.sync="expanded"
        loading-text="Carregando... Por favor aguarde"
        :search="search"
        dense
        class="elevation-1">

        <!-- Items -->
        <template v-slot:item="props">
            <tr>
                <td v-for="header in headers.slice(0, headers.length)" 
                    :key="header.value"
                    :class="header.options.tdClass">
                    <template v-if="header.value === 'actions'"> 
                            <!-- v-if="header.options.expand !== false && checkSubHeaders(subHeaders, props.item)"  -->
                         <v-icon 
                            @click="expanded = (expanded.includes(props.item)) ? [] : [props.item]"
                            small color="green darken-2" class="mr-2">
                            mdi-arrow-expand-vertical
                        </v-icon>
                        <v-icon v-if="header.options.view !== false" small color="green darken-2" class="mr-2" @click="loadItem(props.item, 'view')">
                            mdi-eye
                        </v-icon>
                        <v-icon v-if="header.options.edit !== false" small color="yellow darken-3" class="mr-2" @click="loadItem(props.item, 'edit')">
                            mdi-pencil
                        </v-icon>
                        <v-icon v-if="header.options.delete !== false" small color="red darken-4" @click="loadItem(props.item, 'remove')">
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-else-if="header.options.vChip">  
                        <v-chip 
                            v-for="item in dynamicNestedObjects(props.item, header.value, header.options)" 
                            :key="item"
                            color="primary"
                            dark
                            >
                                {{ item }}
                        </v-chip>
                    </template>
                    <template v-else-if="header.options.component">
                        <component 
                        v-bind:is="header.options.component.vType" 
                        :rotate="header.options.component.rotate"
                        :size="header.options.component.size"
                        :width="header.options.component.width"
                        :height="header.options.component.height"
                        :value="dynamicNestedObjects(props.item, header.value, header.options)"
                        :color="performanceColor(dynamicNestedObjects(props.item, header.value, header.options))"
                        :style="header.options.component.style"
                        dark
                        >
                        {{ dynamicNestedObjects(props.item, header.value, header.options) }}%
                        </component>
                    </template>
                    <template v-else-if="header.secValue"> 
                        {{ dynamicNestedObjects(props.item, header.value, header.options) }}/
                        {{ dynamicNestedObjects(props.item, header.secValue, header.options) }}
                    </template>
                    <template v-else-if="header.options.vEditDialog"> 
                        <v-edit-dialog
                            :return-value.sync="props.item.response"
                            large
                            persistent
                            @save="save"
                            @cancel="cancel"
                            @open="open"
                            @close="close"
                            >

                            <span class="text-center">
                                {{ dynamicNestedObjects(props.item, header.value, header.options) }}
                            </span>
                            <v-icon v-if="header.options.hasOwnProperty('icon')" small :color="header.options.icon.color" class="mr-2">
                                {{ header.options.icon.vType }}
                            </v-icon>
                            
                            <template v-slot:input v-if="header.options.vEditDialogSelect">
                                <v-select
                                    v-model="props.item.response"
                                    :items="props.item.answers"
                                    :hint="`${props.item.response.value} pontos`"
                                    item-text="name"
                                    :label="header.text"
                                    persistent-hint
                                    return-object
                                    single-line
                                    :mask="header.mask"
                                ></v-select>
                            </template>
                            <template v-slot:input v-else>
                                <v-text-field
                                    v-model="props.item[header.value]"
                                    :label="header.text"
                                    single-line
                                    :mask="header.mask"
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                        <!-- <v-snackbar v-model="snack" top :timeout="3000" :color="snackColor">
                            {{ snackText }}
                        </v-snackbar> -->
                    </template>
                    <template v-else>
                        {{ dynamicNestedObjects(props.item, header.value, header.options) }}
                    </template>
                </td>
            </tr>
        </template>

        <!-- Expanded Item -->
        <template v-slot:expanded-item="{item, headers}">
            <table class="v-datatable v-table theme--light">
                <tr v-for="(subItem, n) in subHeaders" :key="n">
                    <td v-for="(subHeader, i) in subHeaders.slice(0, subHeaders.length)" 
                        :key="i"
                        :class="subHeader.options.tdClass"
                        :colspan="subHeader.options.colspan"
                        >
                        
                        <template v-if="i === 0">
                            <v-icon small color="black" class="mr-2">
                                mdi-subdirectory-arrow-right
                            </v-icon>
                        </template>   
                        <template v-if="subHeader.options.vChip">  
                            <v-chip 
                                v-for="item in dynamicNestedObjects(item, subHeader.value, subHeader.options)" 
                                :key="item"
                                color="primary"
                                dark
                                >
                                    {{ item }}
                            </v-chip>
                        </template>
                        <template v-else-if="subHeader.options.component">
                            <component 
                            v-bind:is="subHeader.options.component.vType" 
                            :rotate="subHeader.options.component.rotate"
                            :size="subHeader.options.component.size"
                            :width="subHeader.options.component.width"
                            :height="subHeader.options.component.height"
                            :value="dynamicNestedObjects(item, subHeader.value, subHeader.options)"
                            :color="performanceColor(dynamicNestedObjects(item, subHeader.value, subHeader.options))"
                            >
                            {{ dynamicNestedObjects(item, subHeader.value, subHeader.options) }}%
                            </component>
                        </template>
                        <template v-else-if="subHeader.secValue"> 
                            {{ dynamicNestedObjects(item, subHeader.value, subHeader.options) }}/
                            {{ dynamicNestedObjects(item, subHeader.secValue, subHeader.options) }}
                        </template>
                        <template v-else> 
                            {{ dynamicNestedObjects(item, subHeader.value, subHeader.options) }}
                        </template>
                    </td>
                </tr>
            </table>
        </template>

        <!-- No Data -->
        <template v-slot:no-data>
            <v-alert :value="true" type="error" icon="mdi-alert-outline">
                Desculpe, nenhum registro encontrado :(
            </v-alert>
        </template>

        <!-- No Results  -->
        <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="mdi-alert-outline" class="mt-3">
                Seu filtro por "{{ search }}" não retornou registros.
            </v-alert>
        </template>
    </v-data-table>
</template>

<script>
import moment from '@/config/moment'
export default {
    name: 'Table',
    props: {
        headers: Array,
        subHeaders: Array,
        expand: Boolean,
        items: Array,
    },
    data: function() {
        return {
            snack: false,
            snackColor: '',
            snackText: '',
            expanded: [],
            dialog: false,
            search: '',
            tableLoaded: false,
            dialogNote: {},
        }
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    methods: {
        save () {
            // this.snack = true
            // this.snackColor = 'success'
            // this.snackText = 'Data saved'
            // this.dialog = false
        },
        cancel () {
            // this.snack = true
            // this.snackColor = 'error'
            // this.snackText = 'Canceled'
            // this.dialog = false
        },
        open () {
            // this.snack = true
            // this.snackColor = 'info'
            // this.snackText = 'Dialog opened'
        },
        close () {
            // this.dialog = false
        },

        checkSubHeaders(subheaders, item) {
            for (let i = 0; i < subheaders.length; i++) {
                const element = subheaders[i];
                if (item.hasOwnProperty(element.value)) { return true }
            }

            return false
        },

        dynamicNestedObjects(item, key, options) {
            var obj = (item.hasOwnProperty(options.arrayParent)) ? item[options.arrayParent][item[options.arrayParent].length-1] : item
            key = key.split('.')
			
			while(key.length) {
                if(typeof obj !== 'object') return undefined
                if(Array.isArray(obj)) {
                    var array = []
                    obj.forEach((element) => {
                        array.push(element[key])
                    })
                    key.shift()
                    return array
                } else {
                    obj = obj[key.shift()]
                }
            }
            
            // Formating
            if (options.hasOwnProperty('datePlusWeek')) { obj = moment(obj).format("DD/MM/YYYY, dddd") }
            if (options.hasOwnProperty('slice')) { obj = obj.slice(options.slice) }
            if (options.hasOwnProperty('toUpperCase')) { obj = obj.toUpperCase() }
            if (options.hasOwnProperty('multiplier')) { obj = obj * options.multiplier }
			return obj
        },
        
        performanceColor(performance) {
			let color = 'grey'

			if (performance <= 50) {
				color = 'error'
			} else if (performance <= 60) {
				color = 'warning'
			} else if (performance <= 80) {
				color = 'teal'
			} else if (performance <= 100) {
				color = 'success'
			}

			return color
        },
        performanceText(performance) {
			let text = ''
    
			if (performance <= 50) {
				text = 'Deficiente'
			} else if (performance <= 60) {
				text = 'Bom'
			} else if (performance <= 80) {
				text = 'Muito Bom'
			} else if (performance <= 100) {
				text = 'Excelente'
			}

			return text
		}
    },
    created() {
    }
}
</script>

<style>

</style>